<template>
  <v-card
    :to="getToRoute"
    class="project-card"
  >
    <v-img
      class="project-card__background"
      :class="getRandomGradient()"
      :src="project.images ? project.images[0] : undefined"
      :aspect-ratio="16/9"
    >
      <v-layout
        v-show="project.images"
        slot="placeholder"
        fill-height
        align-center
        justify-center
        ma-0
      >
        <v-progress-circular
          indeterminate
          color="grey lighten-2"
        />
      </v-layout>

      <v-avatar
        v-if="project.image && avatarSize"
        class="project-card__avatar"
        :size="avatarSize"
      >
        <v-img
          :src="project.image"
          :aspect-ratio="1"
          cover
          :alt="project.name"
        />
      </v-avatar>
    </v-img>

    <v-card-title class="project-card__title">
      <div class="headline">
        {{ project.name }}
      </div>
    </v-card-title>
  </v-card>
</template>

<script>
import { getRandomGradient } from '@/utils/gradients'

export default {
  props: {
    avatarSize: {
      type: [String, Number],
      default: 80
    },
    height: {
      type: [String, Number],
      default: 150
    },
    project: {
      required: true,
      type: Object,
      default: () => { }
    },
    to: {
      type: [Boolean],
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    getToRoute () {
      if (this.to) {
        return { name: 'project-details', params: { name: this.project.id } }
      } else {
        return null
      }
    }
  },
  methods: {
    getRandomGradient
  }
}
</script>

<style lang="scss">
.project-card {
  &__background {
    overflow: visible;
  }

  &__avatar {
    position: absolute;
    left: 50%;
    bottom: -44px;
    transform: translateX(-50%);
    background: white;
    padding: 4px;
    box-sizing: content-box;
  }

  &__title {
    padding-top: 44px;
  }
}
</style>
